import { Injectable } from '@angular/core';
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(
    private encryptDecryptService: EncryptDecryptService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {

    // 🚫 Si la solicitud contiene un archivo, no ciframos nada
    if (req.body instanceof FormData) {
      return next.handle(req);
    }

    let clave = this.encryptDecryptService.claveAleatoria();
    const reqClone = req.clone({
      body: { data: this.encryptDecryptService.encryptData(req.body, clave) },
      setHeaders: {
        EncryptedData: this.encryptDecryptService.encryptKey(clave),
      },
    });
    // @ts-ignore
    return next.handle(reqClone).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 403) {
          this.toastr.warning('Su sesion ha expirado', 'Error!');
          this.router.navigateByUrl('/principal');
        }
        if (err.status === 401) {
          this.toastr.error(
            'Acceso no Autorizado, debe Iniciar sesión',
            'Error!',
          );
          this.router.navigateByUrl('/principal');
        }
        this.modalService.dismissAll();
        this.spinner.hide();
        return throwError(() => new Error('Error de Acceso'));
      }),
    );
  }
}
